import { useGetUserRole } from "../../../api/userDetails";
import UserEditModal from "../../lcaUser/userEdit/UserEditModal";

/**
 * Header "Profile" action: reuses the Tailwind `UserEditModal` (lcaUser) so the
 * profile editor looks and behaves like the Users edit drawer. The role stays
 * read-only there (locked after registration).
 */
const UserProfileModal = ({ visibleModal, setVisibleModal, id }: any) => {
  const { data: roles } = useGetUserRole();

  return (
    <UserEditModal
      visibleModal={visibleModal}
      id={id}
      disableEmail
      roles={Array.isArray(roles) ? roles : []}
      closeModal={() => setVisibleModal(false)}
      onSuccess={() => undefined}
    />
  );
};

export default UserProfileModal;
